<template>
  <div class="content-box">
    <div class="page-title">{{title}}（{{titleNum}}）</div>
    <a @click="addCompany" class="add-company" href="javascript:;"><i class="yjh-icon icon-add-company"></i>新增收费企业</a>
    <page-search
      :layout="['code', 'name', 'date']"
      @search="search"
    ></page-search>
    <pageTable
      :loading="tableLoading"
      :col="col"
      :data="tableData"
      :total="total"
      :pageSize="pageSize"
      :pageIndex="page"
      @pageChange="pageChange"
      @pageSizeChange="pageSizeChange"
    ></pageTable>
  </div>
</template>

<script>
import pageTable from '@/components/pageCom/pageTable.vue'
import pageTableMixin from '@/components/pageCom/pageTableMixin.js'
import pageSearch from '@/components/pageCom/pageSearch.vue'
import { getAccountFreeList } from '@/api/userManager'
import Vue from 'vue'
import feeDetail from './components/feeDetail'
Vue.component('feeDetail', feeDetail)
export default {
  name: 'serverVerify',
  components: {
    pageSearch,
    pageTable
  },
  mixins: [pageTableMixin],
  data() {
    return {
      title: '用户手续费管理',
      titleNum: '',
      custNo: '', // 企业编号
      custName: '', // 企业名称
      registerStart: '', // 注册开始时间
      registerEnd: '', // 注册结束时间
      col: [
        { field: 'operation', title: '操作', width: 50, titleAlign: 'left', columnAlign: 'left', isResize: true, componentName: 'userFeeAction' },
        { field: 'cust_no', title: '企业编号', width: 100, titleAlign: 'left', columnAlign: 'left', isResize: true },
        { field: 'type', title: '企业类型', width: 100, titleAlign: 'left', columnAlign: 'left', isResize: true,
          formatter: function(rowData) {
            if (rowData['type'] === '1') {
              return '<span>工业</span>'
            } else if (rowData['type'] === '2') {
              return '<span>服务商</span>'
            }
          }
        },
        { field: 'cust_name', title: '企业名称', width: 100, titleAlign: 'left', columnAlign: 'left', isResize: true },
        { field: 'company_type', title: '手续费', width: 60, titleAlign: 'left', columnAlign: 'left', isResize: true,
          componentName: 'feeDetail' },
        { field: 'company_domain', title: '企业域', width: 100, titleAlign: 'left', columnAlign: 'left', isResize: true },
        { field: 'seller_name', title: '管理员账号', width: 100, titleAlign: 'left', columnAlign: 'left', isResize: true },
        { field: 'company_type', title: '类型', width: 60, titleAlign: 'left', columnAlign: 'left', isResize: true,
          formatter: function(rowData) {
            if (rowData['company_type'] === '1') {
              return '<span>适用</span>'
            } else if (rowData['company_type'] === '2') {
              return '<span>正式</span>'
            }
          }
        },
        { field: '', title: '有效期', width: 200, titleAlign: 'left', columnAlign: 'left', isResize: true,
          formatter: function(rowData) {
            return `<span>${rowData['start_date']} 至 ${rowData['end_date']}</span>`
          }
        },
        { field: 'company_state', title: '状态', width: 60, titleAlign: 'left', columnAlign: 'left', isResize: true,
          formatter: function(rowData) {
            if (rowData['company_state'] === '0') {
              return '<span>关闭</span>'
            } else if (rowData['company_state'] === '1') {
              return '<span>开启</span>'
            } else if (rowData['company_state'] === '2') {
              return '<span>审核</span>'
            }
          }
        }
      ]
    }
  },
  created() {
    this.getData()
  },
  methods: {
    addCompany() { // 新增收费企业
      this.$router.push('/detail/userfee/add')
    },
    search(query) {
      this.custNo = query.code
      this.custName = query.name
      this.registerStart = query.date[0]
      this.registerEnd = query.date[1]
      this.initTable()
      this.getData()
    },
    getData() {
      this.tableLoading = true
      getAccountFreeList({
        cust_no: this.custNo,
        cust_name: this.custName,
        register_start: this.registerStart,
        register_end: this.registerEnd,
        current_page: this.page,
        rp: this.pageSize
      }).then(res => {
        this.tableLoading = false
        const { code, result } = res
        if (code === 0) {
          this.tableData = result.data
          this.total = result.count
          this.titleNum = result.count
        } else if (res.code !== 10008) {
          this.$Message.info(res.msg)
          this.tableData = []
          this.total = 0
          this.titleNum = 0
        }
      })
    }
  }
}
Vue.component('userFeeAction', {
  props: {
    rowData: Object,
    field: String,
    index: Number
  },
  methods: {
    click() {
      this.$router.push('/detail/userfee/' + this.rowData.cust_no)
    }
  },
  render: function(h) {
    return h('span', {
      style: {
        color: '#1881DC',
        fontSize: '12px',
        cursor: 'pointer'
      },
      on: {
        'click': this.click
      }
    }, '编辑')
  }
})
</script>
